import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/jsonMessages';
import ManageNotifications from './ManageNotifications';

export default async function action({ store, intl }) {

  const title = intl?.formatMessage(messages.manageNotifications);

  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
  let privileges = store.getState().listSettings && store.getState().listSettings.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }
  if (!restrictUrls('/siteadmin/notifications', adminPrivileges, privileges)) {
    return { redirect: '/siteadmin' };
  }
  return {
    title,
    component: <AdminLayout><ManageNotifications title={title} /></AdminLayout>,
  };
};
